import { Controller } from "@hotwired/stimulus"

import { applyTheme, currentTheme, isTheme, reflectTheme, rememberTheme, STORAGE_KEY, type Theme } from "../lib/theme_choice"

// The visitor's light/dark/system switch in the footer of a breeder Site
// (`public/shared/appearance`, full phase 093, `doc/palette.md` 10.1).
//
// The page opens in its owner's scheme (`Site#color_scheme`, the `default`
// value); the head script of `layouts/public` has already applied the
// visitor's remembered choice over it before first paint, so the state on
// connect is the `<html>` attribute as it stands. A choice equal to the
// Site's default is forgotten; any other — `system` too, over a light or dark
// Site — is remembered in this host's `localStorage`. Nothing is sent to the
// server: a visitor of a kennel's site is no account of ours.
export default class AppearanceController extends Controller<HTMLElement> {
  static targets = ["option"]
  static values = { default: { type: String, default: "system" } }

  declare readonly optionTargets: HTMLButtonElement[]
  declare readonly defaultValue: string

  connect(): void {
    this.reflect(currentTheme(document.documentElement))
  }

  choose(event: Event & { params?: { choice?: unknown } }): void {
    const choice = event.params?.choice
    if (!isTheme(choice)) return

    applyTheme(document.documentElement, choice)
    rememberTheme(() => window.localStorage, STORAGE_KEY, choice, this.siteDefault())
    this.reflect(choice)
  }

  private siteDefault(): Theme {
    return isTheme(this.defaultValue) ? this.defaultValue : "system"
  }

  private reflect(theme: Theme): void {
    reflectTheme(this.optionTargets, "appearanceChoiceParam", theme)
  }
}
